export const choiceItemDataSet = { cy: 'choice-item' };
